'use es6';

const baseUrl = 'email-parser/v1/setting';
export const updateAutomation = (apiClient, portalId, emailAddress, selectedAutomation) => {
  return apiClient.post(`${baseUrl}?portalId=${portalId}&emailEnabled=${selectedAutomation}&inboxEmail=${emailAddress}`);
};
export const fetchAutomation = (apiClient, portalId, emailAddress) => {
  return apiClient.get(`${baseUrl}?portalId=${portalId}&inboxEmail=${emailAddress}`);
};